import React, { Component } from 'react'
import styles from './Contact.module.css'

class Contact extends Component {
  render() {
    const { content } = this.props.data
    return (
      <div className={styles.Contact}>
        <div
          className={styles.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.js